"use strict";

module.exports = {
  INVENTORY: 'INVENTORY',
  ROOMS: 'ROOMS'
};